import {
  OAuthIntegrationPairingModal
} from './OAuthIntegrationPairingModal';
import {
  attioService
} from "../services/api";
import {
  OnboardingEvents
} from '../analytics/posthog';

interface AttioPairingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  existingLabels?: string[];
}

export function AttioPairingModal({
  isOpen,
  onClose,
  onSuccess,
  existingLabels,
}: AttioPairingModalProps) {
  return (
    <OAuthIntegrationPairingModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      existingLabels={existingLabels}
      name="attio"
      displayName="Attio"
      description="Connect your Attio account so your assistant can read and update CRM records during conversations."
      features={[
        'Search people, companies, and deals',
        'Read record details and linked notes',
        'Create and update records on your behalf',
        'Add notes and tasks to the right record',
      ]}
      accentColor="slate"
      events={{
        modalOpened: OnboardingEvents.ATTIO_MODAL_OPENED,
        oauthStarted: OnboardingEvents.ATTIO_OAUTH_STARTED,
        connected: OnboardingEvents.ATTIO_CONNECTED,
        connectionFailed: OnboardingEvents.ATTIO_CONNECTION_FAILED,
        modalClosed: OnboardingEvents.ATTIO_MODAL_CLOSED,
      }}
      service={attioService}
    />
  );
}
